var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.$t("subtitle")))]),
      _vm._v(" "),
      _c("i18n", { attrs: { path: "info", tag: "p" } }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "mailto:service@gs1-germany.de?subject=API%20Verified%20by%20GS1"
            }
          },
          [_vm._v(_vm._s(_vm.$t("use_apis")))]
        )
      ]),
      _vm._v(" "),
      _vm.limit
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [_vm._v("\n    " + _vm._s(_vm.$t("limitText")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("h3", [
            _vm._v("\n      " + _vm._s(_vm.$t("barcode_numbers")) + "\n      "),
            !_vm.empty
              ? _c("span", { staticClass: "small" }, [
                  _vm._v(
                    "(" +
                      _vm._s(
                        _vm.lines.length +
                          " " +
                          _vm.$tc("entered", _vm.lines.length)
                      ) +
                      ")"
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.text,
                  expression: "text"
                }
              ],
              staticClass: "form-control",
              attrs: {
                maxlength: "16000",
                rows: "10",
                placeholder: _vm.$t("placeholder")
              },
              domProps: { value: _vm.text },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.text = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "or" }, [_vm._v(_vm._s(_vm.$t("or")))]),
          _vm._v(" "),
          _c("h3", [
            _vm._v("\n      " + _vm._s(_vm.$t("file_upload")) + "\n      "),
            _c("span", { staticClass: "small" }, [
              _vm._v("(*.csv, *.txt, *.xlsx)")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              attrs: { type: "file", accept: ".csv,.txt,.xlsx" },
              on: { change: _vm.fileChanged }
            }),
            _vm._v(" "),
            _vm.error
              ? _c("span", { staticClass: "help-block error" }, [
                  _vm._v(
                    _vm._s(_vm.$t("error")) + ": " + _vm._s(_vm.$t(_vm.error))
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit", disabled: _vm.empty || _vm.limit }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("button")) + "\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a2e73b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a2e73b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Bulk.vue
// module id = null
// module chunks = 